import { IAppState } from '../../../AppModulesWrapper';

export function selectJKId(state: IAppState): number | undefined {
  return state.servicePickerWidget.offer.geo?.jk?.id;
}
